export default function CandidateUnauthorized() {
    return (
        <div className="max-w-lg mx-auto p-6 text-center">
            <h1 className="text-2xl font-bold text-red-600 mb-4">Unauthorized</h1>
            <p className="text-gray-700">
                You are not authorized to access this test.
                Please make sure you are using the same email or phone number that was assigned to you.
            </p>
        </div>
    );
}
